import { useState, FormEvent } from "react";

export default function FinalCTA() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    const form = e.currentTarget;
    const data = new URLSearchParams();
    const fields = ["name", "phone", "email", "project"];
    fields.forEach((f) => {
      const el = form.elements.namedItem(f) as HTMLInputElement | HTMLTextAreaElement | null;
      if (el) data.append(f, el.value);
    });
    try {
      await fetch("https://readdy.ai/api/form/d7f7kakq2rhf4jj5qg60", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    }
    setLoading(false);
  };

  return (
    <section id="contact" className="py-28 px-6 bg-stone-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: "url(https://www.archiconservices.com/img/recentprojects-plax.jpg)", backgroundSize: "cover", backgroundPosition: "center" }} />
      <div className="absolute inset-0 bg-stone-900/80" />
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          <div>
            <p className="text-xs tracking-widest uppercase text-amber-400 mb-3" style={{ fontFamily: "'Inter', sans-serif" }}>Get Started</p>
            <h2 className="text-4xl md:text-5xl font-light text-white leading-tight mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              Turn Your Vision Into<br /><em className="not-italic font-semibold">a Designed Reality</em>
            </h2>
            <p className="text-stone-400 text-sm leading-relaxed mb-10" style={{ fontFamily: "'Inter', sans-serif" }}>
              Work with a team that brings clarity, creativity, and precision to every project. Let's discuss your architectural design goals.
            </p>
            <div className="flex flex-col gap-5">
              <a href="tel:+17139276666" className="flex items-center gap-4 group cursor-pointer">
                <div className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-sm group-hover:border-amber-400 transition-colors">
                  <i className="ri-phone-line text-amber-400"></i>
                </div>
                <div>
                  <p className="text-white/50 text-xs tracking-widest uppercase" style={{ fontFamily: "'Inter', sans-serif" }}>Call Us</p>
                  <p className="text-white text-sm font-medium" style={{ fontFamily: "'Inter', sans-serif" }}>(713) 927-6666</p>
                </div>
              </a>
              <a href="mailto:tarit@archiconservices.com" className="flex items-center gap-4 group cursor-pointer">
                <div className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-sm group-hover:border-amber-400 transition-colors">
                  <i className="ri-mail-line text-amber-400"></i>
                </div>
                <div>
                  <p className="text-white/50 text-xs tracking-widest uppercase" style={{ fontFamily: "'Inter', sans-serif" }}>Email</p>
                  <p className="text-white text-sm font-medium" style={{ fontFamily: "'Inter', sans-serif" }}>tarit@archiconservices.com</p>
                </div>
              </a>
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-sm">
                  <i className="ri-map-pin-2-line text-amber-400"></i>
                </div>
                <div>
                  <p className="text-white/50 text-xs tracking-widest uppercase" style={{ fontFamily: "'Inter', sans-serif" }}>Office</p>
                  <p className="text-white text-sm font-medium" style={{ fontFamily: "'Inter', sans-serif" }}>12111 Gladewick Drive, Houston, TX 77077</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white/5 border border-white/10 p-8 rounded-sm">
            {submitted ? (
              <div className="text-center py-12">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-checkbox-circle-line text-4xl text-amber-400"></i>
                </div>
                <h3 className="text-white text-xl font-medium mb-2" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Message Received</h3>
                <p className="text-stone-400 text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>We'll be in touch shortly to discuss your project.</p>
              </div>
            ) : (
              <>
                <h3 className="text-white text-xl font-medium mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Request a Consultation</h3>
                <form data-readdy-form onSubmit={handleSubmit} className="flex flex-col gap-4">
                  <input name="name" required placeholder="Your Name" className="bg-white/5 border border-white/15 text-white placeholder-stone-500 text-sm px-4 py-3 rounded-sm outline-none focus:border-amber-400 transition-colors w-full" style={{ fontFamily: "'Inter', sans-serif" }} />
                  <input name="phone" required placeholder="Phone Number" className="bg-white/5 border border-white/15 text-white placeholder-stone-500 text-sm px-4 py-3 rounded-sm outline-none focus:border-amber-400 transition-colors w-full" style={{ fontFamily: "'Inter', sans-serif" }} />
                  <input name="email" type="email" required placeholder="Email Address" className="bg-white/5 border border-white/15 text-white placeholder-stone-500 text-sm px-4 py-3 rounded-sm outline-none focus:border-amber-400 transition-colors w-full" style={{ fontFamily: "'Inter', sans-serif" }} />
                  <textarea name="project" required placeholder="Tell us about your project..." rows={4} maxLength={500} className="bg-white/5 border border-white/15 text-white placeholder-stone-500 text-sm px-4 py-3 rounded-sm outline-none focus:border-amber-400 transition-colors w-full resize-none" style={{ fontFamily: "'Inter', sans-serif" }} />
                  <button type="submit" disabled={loading} className="bg-amber-500 hover:bg-amber-400 text-stone-900 text-xs tracking-widest uppercase font-semibold py-4 rounded-sm transition-colors duration-300 cursor-pointer whitespace-nowrap disabled:opacity-60" style={{ fontFamily: "'Inter', sans-serif" }}>
                    {loading ? "Sending..." : "Send My Request"}
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
